import {DataControl} from "./DataControl.js";


export class Button extends DataControl {

    getTagName() {
        return 'button';
    }
};